import React, { FC } from 'react';

import Online from '@/components/online/Online';
import { Medium } from '@/constants/mediums';

const WaterOnlinePage: FC = () => {
  return <Online medium={Medium.water} allowMinuteData={false} />;
};

export default WaterOnlinePage;
